import BaseCtrl from 'edge/platform/base/BaseCtrl';
import _ from 'underscore';

var fn = function fn($scope, claimViewModel) {
    var ctrl = Object.create(BaseCtrl);

    ctrl.init = function () {
        $scope.claimVm = claimViewModel();
    };

    ctrl.selectLossCause = function (lossCauseCategory) {
        $scope.claimVm.lossCause.value = lossCauseCategory;
    };

    ctrl.isCollisionSelected = function () {
        return !!_.findWhere($scope.fnol.collisionTypeCodes, {
            'code': $scope.claimVm.lossCause.value.code
        });
    };

    ctrl.isTheftSelected = function () {
        return $scope.claimVm.lossCause.value.code === 'theftentire' || $scope.claimVm.lossCause.value.code === 'theftparts';
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', 'claimViewModel'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/fnol/ca/controllers/CAClaimTypeCtrl.js
// module id = 1495
// module chunks = 0